const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.85565 2.94434C7.86725 2.94434 6.25565 4.55594 6.25565 6.54434V7.14434C6.25565 9.13274 7.86725 10.7443 9.85565 10.7443C11.8441 10.7443 13.4557 9.13274 13.4557 7.14434V6.54434C13.4557 4.55594 11.8441 2.94434 9.85565 2.94434ZM9.85448 12.5443C7.45088 12.5443 4.36688 13.8444 3.47948 14.9982C2.93108 15.7116 3.45313 16.7443 4.35253 16.7443H15.3576C16.257 16.7443 16.7791 15.7116 16.2307 14.9982C15.3433 13.845 12.2581 12.5443 9.85448 12.5443Z",
    fill: "url(#paint0_linear_460_827)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_827",
    x1: 9.85507,
    y1: 2.94434,
    x2: 9.85507,
    y2: 16.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA80E6",
    style: {
      stopColor: "#BA80E6",
      stopColor: "color(display-p3 0.7294 0.5020 0.9020)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92ABFC",
    style: {
      stopColor: "#92ABFC",
      stopColor: "color(display-p3 0.5725 0.6706 0.9882)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.7645569ce7dc2ce6b6ebd660691b05e46bf5d95c69ebddd5bd14440c27f6b0a3.svg";
export { ForwardRef as ReactComponent };